import React, { useMemo } from "react";
import { FaTimes, FaFileInvoice } from "react-icons/fa";
import useDrawerTransition from "../../../Hooks/useDrawerTransition";
import BillDetailContent from "./BillDetailContent";

/**
 * Faturalar sekmesi — satıra tıklayınca sağdan açılan fatura detay drawer'ı
 * (ManualQuotaDrawer kabuk deseni). Storage ve dealer BillsTab'leri ortak
 * kullanır; işlem türü rozet bilgisi (renk/başlık) parent'tan gelir. Gövde
 * BillDetailContent'tedir (Uyarılar'daki son sipariş paneliyle ortak, #367).
 */

const BillDetailDrawer = ({
  open,
  onClose,
  bill: billProp,
  typeDetails: typeDetailsProp = null,
  note: noteProp = "",
}) => {
  // Giriş/çıkış kayması + kapanışta fatura içeriğinin dondurulması (çağıran
  // taraf kapatırken bill'i null'a çekiyor).
  const frozenData = useMemo(
    () => ({ bill: billProp, typeDetails: typeDetailsProp, note: noteProp }),
    [billProp, typeDetailsProp, noteProp]
  );
  const { mounted, entered, data: view } = useDrawerTransition(open, frozenData);
  const bill = view?.bill ?? billProp;
  const typeDetails = view?.typeDetails ?? typeDetailsProp;
  const note = view?.note ?? noteProp;

  return (
    <>
      {/* Panel */}
      <div
        className={`fixed inset-y-0 right-0 w-full sm:w-[480px] transform ${
          entered ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out shadow-2xl z-[9997] flex flex-col bg-gray-50`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 bg-white border-b border-gray-200 shrink-0">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-indigo-100 shrink-0">
              <FaFileInvoice className="w-4 h-4 text-indigo-600" />
            </div>
            <div className="min-w-0">
              <h3 className="text-base font-bold text-gray-800 truncate">Fatura Detayı</h3>
              <p className="text-sm text-gray-500 font-mono truncate">{bill?.billNo || "-"}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2.5 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors shrink-0"
          >
            <FaTimes className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        {bill && (
          <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4 space-y-3">
            <BillDetailContent bill={bill} typeDetails={typeDetails} note={note} />
          </div>
        )}
      </div>

      {/* Backdrop */}
      {mounted && (
        <div
          className={`fixed inset-0 bg-black/30 backdrop-blur-sm z-[9996] transition-opacity duration-300 ease-in-out ${entered ? "opacity-100" : "opacity-0"}`}
          onClick={onClose}
        />
      )}
    </>
  );
};

export default BillDetailDrawer;
